export default "__VITE_ASSET__BZchBaxu__"